var chunkMapping = {
	"webpack_container_remote_admin_Routes": [
		51069
	],
	"webpack_container_remote_lms_Routes": [
		86310
	],
	"webpack_container_remote_serving_Routes": [
		57490
	]
};
var idToExternalAndNameMapping = {
	"51069": [
		"default",
		"./Routes",
		59001
	],
	"57490": [
		"default",
		"./Routes",
		88242
	],
	"86310": [
		"default",
		"./Routes",
		34222
	]
};
var idToRemoteMap = {
	"51069": [
		{
			"externalType": "module",
			"name": ""
		}
	],
	"57490": [
		{
			"externalType": "module",
			"name": ""
		}
	],
	"86310": [
		{
			"externalType": "module",
			"name": ""
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes.chunkMapping = chunkMapping;
__webpack_require__.federation.bundlerRuntimeOptions.remotes.idToExternalAndNameMapping = idToExternalAndNameMapping;
__webpack_require__.federation.bundlerRuntimeOptions.remotes.idToRemoteMap = idToRemoteMap;
__webpack_require__.remotesLoadingData.moduleIdToRemoteDataMapping = {
	"51069": {
		"shareScope": "default",
		"name": "./Routes",
		"externalModuleId": 59001,
		"remoteName": ""
	},
	"57490": {
		"shareScope": "default",
		"name": "./Routes",
		"externalModuleId": 88242,
		"remoteName": ""
	},
	"86310": {
		"shareScope": "default",
		"name": "./Routes",
		"externalModuleId": 34222,
		"remoteName": ""
	}
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}